import { Injectable } from '@angular/core';
import { GridDataService } from '../../base-data-services/grid-data.service';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { GridParams, GridPostParams } from 'common/models/utility-models/list-utility.model';
// import { LocationGridPostParams, LocationListingModel, LocationModel } from 'common/models/page-models/location-model';
import { environment } from 'src/environments/environment';
import { LocationModel } from 'common/models/page-models/Location/location-data-model';
import { LocationListingModel, LocationGridPostParams } from 'common/models/page-models/Location/location-grid-model';






@Injectable({
    providedIn: 'root'
})
export class LocationGridDataService extends GridDataService<LocationListingModel, LocationModel> {
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.locationGrid, http, ss);
        
    }

    createInstance(): LocationListingModel {
        return new LocationListingModel();
    }

    override getGridParams(param): GridPostParams {
        return new LocationGridPostParams();
    }

    override getDeleteUrl(): string {
        return environment.apiUrl+API_URL.deleteLocation;
    }

    override getDeletePayload(data){
        let payload;
        if(data.cityID){
            payload={id:data.cityID}
        }
        else{
            payload=data;
        }
        
        return payload;
    }

    override transformDataModel(apiRes: any, param: string) {
        super.transformDataModel(apiRes, 'details');
        // console.log("APIRES",apiRes, param);
        if (apiRes[param] && Array.isArray(apiRes[param])) {
            apiRes[param].sort((a, b) => {
                if (a.city_name && b.city_name) {
                    return a.city_name.localeCompare(b.city_name);
                }
                return 0;
            });
        }
        return apiRes;
    }

}
